(() => {
// Farbwerte der Stoffe. Blue Fog, Sage, Soft Rose, Off White und Weiß sind aus den Produktfotos gemessen,
// Schwarz und Heather Grey: Schaetzwerte, von Raffael freigegeben.
const COLOURS = {
  "Weiß":         { hex: "#f7f7f7", dark: false },
  "Off White":    { hex: "#e8e0d3", dark: false },
  "Heather Grey": { hex: "#b9b9bd", dark: false },
  "Soft Rose":    { hex: "#e9c5b8", dark: false },
  "Sage":         { hex: "#9eb6a9", dark: false },
  "Blue Fog":     { hex: "#9aacb6", dark: false },
  "Schwarz":      { hex: "#2a2a2e", dark: true  },
};

// Reihenfolge der Produkte im UI
const PRODUCT_ORDER = [
  "t-shirt-unisex", "t-shirt-women",
  "sweater-unisex", "sweater-women",
  "hoodie-unisex", "hoodie-women",
];

// Druckformat der Tasche (Stand 2026-09-04, von Raffael bestaetigt, gilt fuer alle Produkte):
// Druckdatei 12 x 15 cm. Umschlag/Nahtzugabe: 1 cm links, rechts, unten und 1,5 cm oben.
// Sichtbar bleibt 10 x 12,5 cm. Werte in cm.
const PRINT = {
  widthCm: 12, heightCm: 15,
  fold: { top: 1.5, right: 1, bottom: 1, left: 1 },
  pxPerCmOk: 100,     // ~254 dpi -> gut
  pxPerCmWarn: 80,    // ~200 dpi -> Druck moeglich, nicht optimal
  aspectTolerance: 0.03, // Abweichung vom Zielformat, ab der wir "wird zugeschnitten" melden
};

const LIMITS = {
  maxBytes: 20 * 1024 * 1024,
  types: ["image/png", "image/jpeg", "image/svg+xml"],
};

// URL des Upload-Workers (Cloudflare). Leer = lokaler Demo-Modus ohne Upload.
const UPLOAD_URL = "https://mps-design-upload.mypocketshirt.workers.dev/upload";


// Lokal: Daten aus ../data/products.json und Bilder aus ../assets. Im Theme liefert die Liquid-Sektion
// window.MPS_DATA (Produkte, Varianten, Taschen) und window.MPS_ASSETS (Bild-URLs pro Handle).
const ROOT = "../";
const THEME = typeof window !== "undefined" && window.MPS_DATA ? window.MPS_DATA : null;
const assetUrl = (handle, base) => THEME ? window.MPS_ASSETS[handle + (base ? "-base" : "")] : `${ROOT}assets/mockups/${handle}${base ? "-base" : ""}.png`;
const $ = (id) => document.getElementById(id);
const track = (name, props) => { try { if (window.plausible) window.plausible(name, props ? { props } : undefined); } catch (e) {} };

const state = {
  products: null, product: null, colour: "Weiß", size: null,
  file: null, image: null, meta: null, check: null, showFold: false, replaceKey: null,
  cropX: 0.5, keepCrop: false,                                  // horizontale Lage des Ausschnitts: 0 = linker Rand, 0.5 = Mitte, 1 = rechter Rand
  mockups: {}, tinted: {},
};

// Druckformat: voll bedruckt, sichtbar = Format minus Umschlag
const visibleCm = () => ({
  w: PRINT.widthCm - PRINT.fold.left - PRINT.fold.right,
  h: PRINT.heightCm - PRINT.fold.top - PRINT.fold.bottom,
});

// ---------- Laden ----------
async function init() {
  const data = THEME || await fetch(ROOT + "data/products.json").then((r) => r.json());
  state.products = data.products;
  renderProducts(); renderSwatches();
  const q = new URLSearchParams(location.search);
  const wanted = q.get("basic") || q.get("product");
  const preset = wanted && state.products[wanted] ? wanted : PRODUCT_ORDER[0];
  if (q.get("colour") && COLOURS[q.get("colour")]) state.colour = q.get("colour");
  await selectProduct(preset); selectColour(state.colour);
  if (q.get("size")) { const b = [...$("sizes").children].find((el) => el.textContent === q.get("size")); if (b) b.click(); }
  if (q.get("key")) { state.replaceKey = q.get("key"); $("add").textContent = "Warenkorb aktualisieren"; }
  if (q.get("crop") !== null && !isNaN(parseFloat(q.get("crop")))) { state.cropX = Math.min(1, Math.max(0, parseFloat(q.get("crop")))); state.keepCrop = true; }
  if (q.get("file")) loadExistingDesign(q.get("file"), q.get("name") || "design");
  else if (q.get("fid") && q.get("ref") && UPLOAD_URL) {
    fetch(UPLOAD_URL.replace(/\/upload$/, "/file-url") + "?id=" + encodeURIComponent(q.get("fid")) + "&ref=" + encodeURIComponent(q.get("ref"))).then((r) => r.json())
      .then((d) => d.url ? loadExistingDesign(d.url, q.get("name") || "design") : designLoadFailed()).catch(designLoadFailed);
  }
  if (location.hash === "#mps-designer") setTimeout(() => $("mps-designer").scrollIntoView({ behavior: "smooth", block: "start" }), 300);
  bindUpload(); bindCrop();
  $("fold").addEventListener("change", (e) => { state.showFold = e.target.checked; draw(); });
  $("add").addEventListener("click", addToCart);
  const defaultNote = `PNG, JPG oder SVG · max. 20 MB · Format ${PRINT.widthCm} × ${PRINT.heightCm} cm, am besten mind. ${PRINT.widthCm * PRINT.pxPerCmOk} × ${PRINT.heightCm * PRINT.pxPerCmOk} px`;
  const applyOccasion = (o) => { $("drop-note").textContent = o && o.hint ? `${o.hint} · PNG, JPG oder SVG, max. 20 MB` : defaultNote; };
  applyOccasion(window.MPS_OCCASION);
  document.addEventListener("mps:anlass", (e) => applyOccasion(e.detail));   // Anlass-Picker (Schritt 1) meldet Auswahl
  if (!THEME) $("debug").hidden = false;
}

function loadMockup(handle) {
  if (state.mockups[handle]) return state.mockups[handle];
  const img = new Image();
  img.crossOrigin = "anonymous";   // CDN-Bilder sonst "tainted", getImageData fuer das Einfaerben schlaegt fehl
  const p = new Promise((res, rej) => { img.onload = () => res(img); img.onerror = rej; });
  img.src = assetUrl(handle, true);
  return (state.mockups[handle] = p);
}

// ---------- UI ----------
function renderProducts() {
  const box = $("products"); box.innerHTML = "";
  for (const h of PRODUCT_ORDER) {
    const p = state.products[h];
    const [type, fit] = p.title.split(" ");
    const b = document.createElement("button");
    b.type = "button"; b.className = "mps__product"; b.role = "radio"; b.setAttribute("aria-checked", "false"); b.dataset.handle = h;
    b.innerHTML = `<img src="${assetUrl(h, false)}" alt=""><span>${type}<small>${fit}</small></span>`;
    b.addEventListener("click", () => selectProduct(h));
    box.appendChild(b);
  }
}
function renderSwatches() {
  const box = $("swatches"); box.innerHTML = "";
  for (const [name, c] of Object.entries(COLOURS)) {
    const b = document.createElement("button");
    b.type = "button"; b.className = "mps__swatch"; b.role = "radio"; b.setAttribute("aria-checked", "false"); b.title = name; b.dataset.colour = name;
    b.style.background = c.hex; b.setAttribute("aria-label", name);
    b.addEventListener("click", () => selectColour(name));
    box.appendChild(b);
  }
}
function renderSizes() {
  const box = $("sizes"); box.innerHTML = "";
  for (const s of state.products[state.product].sizes) {
    const b = document.createElement("button");
    b.type = "button"; b.className = "mps__sizebtn"; b.role = "radio"; b.setAttribute("aria-checked", "false"); b.textContent = s;
    b.addEventListener("click", () => { state.size = s; syncChecked("sizes", (el) => el.textContent === s); updateCta(); });
    box.appendChild(b);
  }
  state.size = null; updateCta();
}
function syncChecked(id, pred) {
  for (const el of $(id).children) el.setAttribute("aria-checked", pred(el) ? "true" : "false");
}

async function selectProduct(h) {
  state.product = h; track("Basic gewählt", { basic: h });
  syncChecked("products", (el) => el.dataset.handle === h);
  if (!state.products[h].colours.includes(state.colour)) selectColour(state.products[h].colours[0]);
  renderSizes();
  await loadMockup(h); draw();
}
function selectColour(name) {
  state.colour = name;
  syncChecked("swatches", (el) => el.dataset.colour === name);
  $("colour-name").textContent = name;
  draw();
}

// ---------- Upload + Qualitaets-Check ----------
function bindUpload() {
  const drop = $("drop"), input = $("file");
  input.addEventListener("change", () => input.files[0] && handleFile(input.files[0]));
  ["dragenter", "dragover"].forEach((ev) => drop.addEventListener(ev, (e) => { e.preventDefault(); drop.classList.add("is-over"); }));
  ["dragleave", "drop"].forEach((ev) => drop.addEventListener(ev, (e) => { e.preventDefault(); drop.classList.remove("is-over"); }));
  drop.addEventListener("drop", (e) => e.dataTransfer.files[0] && handleFile(e.dataTransfer.files[0]));
}

async function handleFile(file) {
  const issues = []; let level = "ok";
  const isSvg = file.type === "image/svg+xml" || /\.svg$/i.test(file.name);
  const typeOk = LIMITS.types.includes(file.type) || isSvg;
  if (!typeOk) return showCheck("bad", "Dieses Format können wir nicht drucken.", ["Bitte lade ein PNG, JPG oder SVG hoch."]);
  if (file.size > LIMITS.maxBytes) return showCheck("bad", "Die Datei ist zu groß.", [`Maximal 20 MB, deine Datei hat ${(file.size / 1048576).toFixed(1)} MB.`]);

  let img;
  try { img = await readImage(file); }
  catch { return showCheck("bad", "Die Datei lässt sich nicht öffnen.", ["Bitte probiere eine andere Datei."]); }

  const w = img.naturalWidth, h = img.naturalHeight;
  const meta = { name: file.name, type: isSvg ? "image/svg+xml" : file.type, bytes: file.size, width: w, height: h, vector: isSvg };

  // Seitenverhaeltnis gegen das Druckformat
  const target = PRINT.widthCm / PRINT.heightCm, actual = w / h;
  const dev = Math.abs(actual - target) / target;
  if (dev > PRINT.aspectTolerance) {
    level = "warn";
    issues.push(`Dein Bild hat nicht ganz das Taschenformat (${PRINT.widthCm} × ${PRINT.heightCm} cm). Wir schneiden es zu. Mit „Bild groß ansehen“ siehst du den Ausschnitt und kannst ihn nach links oder rechts schieben.`);
  }
  // Aufloesung: Pixel pro cm bezogen auf die Seite, die das Format bestimmt
  if (isSvg) {
    issues.push("SVG erkannt: verlustfrei skalierbar, perfekt für den Druck.");
  } else {
    const cropW = actual > target ? h * target : w;          // Breite in px nach Zuschnitt
    const pxPerCm = cropW / PRINT.widthCm;
    if (pxPerCm < PRINT.pxPerCmWarn) {
      return showCheck("bad", "Die Auflösung reicht für einen guten Druck nicht aus.", [
        `Dein Bild hat ${w} × ${h} px. Für ${PRINT.widthCm} × ${PRINT.heightCm} cm brauchen wir mindestens ${PRINT.widthCm * PRINT.pxPerCmWarn} × ${PRINT.heightCm * PRINT.pxPerCmWarn} px, besser ${PRINT.widthCm * PRINT.pxPerCmOk} × ${PRINT.heightCm * PRINT.pxPerCmOk} px.`,
        "Tipp: Bei Fotos das Original vom Handy nehmen, nicht die Version aus WhatsApp oder Instagram.",
      ]);
    } else if (pxPerCm < PRINT.pxPerCmOk) {
      level = "warn"; issues.push(`${w} × ${h} px: Druck möglich, aber nicht optimal. Ab ${PRINT.widthCm * PRINT.pxPerCmOk} × ${PRINT.heightCm * PRINT.pxPerCmOk} px wird es richtig scharf.`);
    } else {
      issues.push(`${w} × ${h} px: Auflösung passt.`);
    }
  }
  issues.push(`${PRINT.fold.left} cm an den Seiten und unten sowie ${String(PRINT.fold.top).replace(".", ",")} cm oben werden beim Annähen umgeschlagen. Die Vorschau zeigt nur, was sichtbar bleibt.`);

  // Grosse Fotos vor dem Upload verkleinern: Shopify Files lehnt Bilder ueber 20 Megapixel ab, und der Upload wird sonst unnoetig langsam
  if (!isSvg) {
    const o = await optimizeForUpload(file, img).catch(() => null);
    if (o) { file = o.file; img = o.img; meta.origPx = [w, h]; meta.origBytes = meta.bytes; meta.width = img.naturalWidth; meta.height = img.naturalHeight; meta.bytes = file.size; meta.type = file.type; meta.name = file.name; }
    else if (w * h > UPLOAD_MAX_PIXELS) return showCheck("bad", "Dein Bild ist sehr groß.", [`${w} × ${h} px sind mehr, als wir verarbeiten können. Bitte verkleinere es auf höchstens 4500 px an der langen Seite, das reicht für den Druck locker.`]);
  }
  state.file = file; state.image = img; state.meta = meta; state.check = level;
  if (!state.keepCrop) state.cropX = 0.5; state.keepCrop = false;
  $("fold-row").hidden = false; document.querySelectorAll(".js-crop-open").forEach((b) => { b.hidden = false; }); $("alt-link").hidden = true; showDropFilled(file, img); $("stage-hint").hidden = true;
  showCheck(level, level === "ok" ? "Sieht gut aus!" : "Passt, mit einem Hinweis:", issues); track("Design hochgeladen", { check: level, type: meta.vector ? "svg" : "raster" });
  draw(); updateCta();
}

// Bestehendes Design aus dem Warenkorb wieder laden (CDN-Datei -> File -> normaler Upload-Weg)
async function loadExistingDesign(url, name) {
  try {
    if (!/^https:\/\/cdn\.shopify\.com\//.test(url)) return;
    const res = await fetch(url, { mode: "cors" });
    if (!res.ok) return designLoadFailed();
    const blob = await res.blob();
    const type = blob.type || (/\.svg/i.test(url) ? "image/svg+xml" : /\.png/i.test(url) ? "image/png" : "image/jpeg");
    await handleFile(new File([blob], name, { type }));
  } catch (e) { console.warn("Design konnte nicht geladen werden", e); designLoadFailed(); }
}
function designLoadFailed() { showCheck("warn", "Dein Bild konnten wir nicht wieder laden.", ["Bitte lade es hier noch einmal hoch, dann kannst du es ändern."]); }

// Upload-Groesse begrenzen: hoechstens 16 Megapixel und 4500 px an der langen Seite (Druck braucht 1417 x 1772 px bei 300 dpi)
const UPLOAD_MAX_PIXELS = 16e6, UPLOAD_MAX_SIDE = 4500, UPLOAD_SHRINK_BYTES = 8 * 1024 * 1024;
async function optimizeForUpload(file, img) {
  const w = img.naturalWidth, h = img.naturalHeight;
  if (w * h <= UPLOAD_MAX_PIXELS && Math.max(w, h) <= UPLOAD_MAX_SIDE && file.size <= UPLOAD_SHRINK_BYTES) return null;
  const k = Math.min(1, Math.sqrt(UPLOAD_MAX_PIXELS / (w * h)), UPLOAD_MAX_SIDE / Math.max(w, h));
  const c = document.createElement("canvas"); c.width = Math.round(w * k); c.height = Math.round(h * k);
  const ctx = c.getContext("2d"); ctx.imageSmoothingQuality = "high";
  const toBlob = (type, q) => new Promise((r) => c.toBlob(r, type, q));
  let type = file.type === "image/png" ? "image/png" : "image/jpeg";
  if (type === "image/jpeg") { ctx.fillStyle = "#fff"; ctx.fillRect(0, 0, c.width, c.height); }
  ctx.drawImage(img, 0, 0, c.width, c.height);
  let blob = await toBlob(type, 0.92);
  if (blob && type === "image/png" && blob.size > 12 * 1024 * 1024) {      // riesiges PNG: als JPG auf Weiss
    const c2 = document.createElement("canvas"); c2.width = c.width; c2.height = c.height; const x2 = c2.getContext("2d");
    x2.fillStyle = "#fff"; x2.fillRect(0, 0, c2.width, c2.height); x2.drawImage(c, 0, 0);
    blob = await new Promise((r) => c2.toBlob(r, "image/jpeg", 0.92)); type = "image/jpeg";
  }
  if (!blob || blob.size < 1000) throw new Error("optimize");
  const name = file.name.replace(/\.[^.]+$/, "") + (type === "image/png" ? ".png" : ".jpg");
  const out = new File([blob], name, { type });
  return { file: out, img: await readImage(out) };
}
// Upload mit Zeitlimit und einem automatischen zweiten Versuch bei Verbindungsfehlern
async function uploadDesign(form, onRetry) {
  for (let attempt = 1; ; attempt++) {
    const ctl = new AbortController(), timer = setTimeout(() => ctl.abort(), 120000);
    try {
      const res = await fetch(UPLOAD_URL, { method: "POST", body: form, signal: ctl.signal });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) { const e = new Error(data.error || "Upload fehlgeschlagen"); e.final = res.status < 500; throw e; }
      return data;
    } catch (err) {
      if (err.final || attempt >= 2) { if (!err.final && (err.name === "AbortError" || err instanceof TypeError)) throw new Error("Die Verbindung wurde unterbrochen. Bitte prüf dein Internet und versuch es noch einmal."); throw err; }
      track("Upload Wiederholung", { grund: err.name || "fehler" }); if (onRetry) onRetry();
      await new Promise((r) => setTimeout(r, 1500));
    } finally { clearTimeout(timer); }
  }
}
function readImage(file) {
  return new Promise((res, rej) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => res(img);
    img.onerror = () => { URL.revokeObjectURL(url); rej(); };
    img.src = url;
  });
}

function showDropFilled(file, img) {
  const drop = $("drop");
  drop.classList.add("is-filled"); drop.querySelector(".mps__drop-empty").hidden = true; $("drop-filled").hidden = false;
  $("drop-thumb").src = img.src; $("drop-name").textContent = file.name;
  $("drop-dims").textContent = state.meta.vector ? "SVG, verlustfrei skalierbar" : `${img.naturalWidth} × ${img.naturalHeight} px`;
}
function showDropEmpty() {
  const drop = $("drop"); drop.classList.remove("is-filled"); drop.querySelector(".mps__drop-empty").hidden = false; $("drop-filled").hidden = true;
}

function showCheck(level, title, lines) {
  const box = $("check"); box.hidden = false;
  box.className = `mps__check mps__check--${level}`;
  box.innerHTML = `<strong>${title}</strong><ul>${lines.map((l) => `<li>${l}</li>`).join("")}</ul>`;
  if (level === "bad") { track("Upload abgelehnt", { grund: title }); state.file = state.image = state.meta = null; state.check = "bad"; $("fold-row").hidden = true; showDropEmpty(); draw(); updateCta(); }
}

// ---------- Einfaerben ----------
// Die Basis ist auf Stoff = 248 normiert. Pro Pixel: Helligkeit -> Schattierung -> Zielfarbe.
// Dunkle Stoffe zeigen Falten weniger tief, dafuer leichte Glanzlichter, sonst wirkt es wie ein flacher Aufkleber.
function tintedMockup(handle, colourName) {
  const key = handle + "|" + colourName;
  if (state.tinted[key]) return state.tinted[key];
  const base = state.mockups[handle + "|img"];
  const c = COLOURS[colourName];
  const [r, g, b] = [1, 3, 5].map((i) => parseInt(c.hex.slice(i, i + 2), 16));
  const off = document.createElement("canvas"); off.width = base.width; off.height = base.height;
  const ctx = off.getContext("2d"); ctx.drawImage(base, 0, 0);
  const id = ctx.getImageData(0, 0, off.width, off.height), d = id.data;
  const depth = c.dark ? 0.55 : 1.0;      // wie stark Schatten durchkommen
  const gloss = c.dark ? 0.35 : 0.0;      // Glanzlicht auf dunklem Stoff
  for (let i = 0; i < d.length; i += 4) {
    if (d[i + 3] === 0) continue;
    const lum = (0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2]) / 248;
    const shade = 1 - depth * (1 - Math.min(lum, 1));
    const hi = Math.max(0, lum - 1) * gloss * 255;
    d[i] = Math.min(255, r * shade + hi); d[i + 1] = Math.min(255, g * shade + hi); d[i + 2] = Math.min(255, b * shade + hi);
  }
  ctx.putImageData(id, 0, 0);
  return (state.tinted[key] = off);
}

// ---------- Vorschau ----------
// Quellrechteck des Druckformats im Bild (Bildpixel). movable = Bild breiter als 4:5, also links/rechts verschiebbar
function cropRect() {
  const img = state.image, iw = img.naturalWidth, ih = img.naturalHeight;
  const target = PRINT.widthCm / PRINT.heightCm;
  let sw = iw, sh = ih; if (iw / ih > target) sw = ih * target; else sh = iw / target;
  const sx = (iw - sw) * state.cropX, sy = (ih - sh) / 2;
  return { iw, ih, sx, sy, sw, sh, pxCm: sw / PRINT.widthCm, movable: iw - sw > 1 };
}
async function draw() {
  const canvas = $("stage"), ctx = canvas.getContext("2d");
  const p = state.products[state.product];
  const base = await loadMockup(state.product); state.mockups[state.product + "|img"] = base;
  const col = COLOURS[state.colour];
  const W = canvas.width, H = canvas.height;

  ctx.clearRect(0, 0, W, H);
  ctx.globalCompositeOperation = "source-over";
  ctx.drawImage(tintedMockup(state.product, state.colour), 0, 0, W, H);

  // Sichtbarer Taschenbereich: Format minus Umschlag, mittig ins Taschen-Rechteck des Fotos eingepasst
  const r = p.pocket, vis = visibleCm();
  const s = Math.min(r.w / vis.w, r.h / vis.h);                // px pro cm im Mockup
  const vw = vis.w * s, vh = vis.h * s, vx = r.x + (r.w - vw) / 2, vy = r.y + (r.h - vh) / 2;

  if (!state.image) {
    ctx.save(); ctx.setLineDash([6, 5]); ctx.lineWidth = 1.5;
    ctx.strokeStyle = col.dark ? "rgba(255,255,255,.55)" : "rgba(59,66,88,.45)";
    ctx.strokeRect(vx, vy, vw, vh); ctx.restore();
    return;
  }

  // Bild mittig auf das Druckformat zuschneiden (Quellrechteck in Bildpixeln)
  const img = state.image, { sx, sy, sw, sh, pxCm } = cropRect();
  // Sichtbarer Ausschnitt = Umschlag abziehen
  const cx = sx + PRINT.fold.left * pxCm, cy = sy + PRINT.fold.top * pxCm, cw = vis.w * pxCm, ch = vis.h * pxCm;

  ctx.save();
  ctx.globalCompositeOperation = "source-over";
  if (state.showFold) {
    // Ganzes Druckformat zeigen, umgeschlagener Rand abgedunkelt
    const fx = vx - PRINT.fold.left * s, fy = vy - PRINT.fold.top * s, fw = PRINT.widthCm * s, fh = PRINT.heightCm * s;
    ctx.drawImage(img, sx, sy, sw, sh, fx, fy, fw, fh);
    ctx.globalCompositeOperation = "source-over";
    ctx.fillStyle = "rgba(59,66,88,.55)";
    ctx.beginPath(); ctx.rect(fx, fy, fw, fh); ctx.rect(vx, vy, vw, vh); ctx.fill("evenodd");
    ctx.setLineDash([5, 4]); ctx.strokeStyle = "#fff"; ctx.lineWidth = 1.5; ctx.strokeRect(vx, vy, vw, vh);
  } else {
    ctx.drawImage(img, cx, cy, cw, ch, vx, vy, vw, vh);
  }
  ctx.restore();
}

// ---------- Ausschnitt-Ansicht (Modal): ganzes Bild, Druckformat und sichtbarer Bereich, links/rechts verschieben ----------
function bindCrop() {
  const modal = $("crop-modal"), canvas = $("crop-canvas"), range = $("crop-range");
  let lastFocus = null, drag = null;
  const open = () => { lastFocus = document.activeElement; modal.hidden = false; document.body.classList.add("mps-modal-open"); renderCrop(); $("crop-close").focus(); track("Ausschnitt geöffnet"); };
  const close = () => { modal.hidden = true; document.body.classList.remove("mps-modal-open"); if (lastFocus && lastFocus.focus) lastFocus.focus(); };
  document.querySelectorAll(".js-crop-open").forEach((b) => b.addEventListener("click", open));
  modal.querySelectorAll("[data-crop-close]").forEach((el) => el.addEventListener("click", close));
  document.addEventListener("keydown", (e) => { if (!modal.hidden && e.key === "Escape") close(); });
  const setCrop = (v) => { state.cropX = Math.min(1, Math.max(0, v)); range.value = Math.round(state.cropX * 1000); renderCrop(); draw(); };
  range.addEventListener("input", () => setCrop(range.value / 1000));
  $("crop-center").addEventListener("click", () => setCrop(0.5));
  // Ziehen mit Maus oder Finger
  canvas.addEventListener("pointerdown", (e) => { if (!cropRect().movable) return; drag = { x: e.clientX, crop: state.cropX }; canvas.setPointerCapture(e.pointerId); canvas.classList.add("is-dragging"); });
  canvas.addEventListener("pointermove", (e) => {
    if (!drag) return;
    const r = cropRect(), scale = canvas.getBoundingClientRect().width / canvas.width;   // CSS-px pro Canvas-px
    const imgPx = (e.clientX - drag.x) / scale / (canvas.width / r.iw);                    // Bewegung in Bildpixeln
    setCrop(drag.crop + imgPx / (r.iw - r.sw));
  });
  ["pointerup", "pointercancel"].forEach((ev) => canvas.addEventListener(ev, () => { drag = null; canvas.classList.remove("is-dragging"); }));
}
function renderCrop() {
  if (!state.image) return;
  const canvas = $("crop-canvas"), ctx = canvas.getContext("2d"), r = cropRect(), vis = visibleCm();
  const max = 900, k = Math.min(max / r.iw, max / r.ih, 1);
  canvas.width = Math.round(r.iw * k); canvas.height = Math.round(r.ih * k);
  ctx.fillStyle = "#fff"; ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(state.image, 0, 0, canvas.width, canvas.height);
  const fx = r.sx * k, fy = r.sy * k, fw = r.sw * k, fh = r.sh * k, pc = r.pxCm * k;
  const vx = fx + PRINT.fold.left * pc, vy = fy + PRINT.fold.top * pc, vw = vis.w * pc, vh = vis.h * pc;
  // Ausserhalb des Druckformats: stark abgedunkelt. Umschlag: leicht abgedunkelt.
  ctx.fillStyle = "rgba(44,40,36,.72)"; ctx.beginPath(); ctx.rect(0, 0, canvas.width, canvas.height); ctx.rect(fx, fy, fw, fh); ctx.fill("evenodd");
  ctx.fillStyle = "rgba(59,66,88,.45)"; ctx.beginPath(); ctx.rect(fx, fy, fw, fh); ctx.rect(vx, vy, vw, vh); ctx.fill("evenodd");
  ctx.lineWidth = Math.max(2, canvas.width / 300); ctx.strokeStyle = "#fff"; ctx.strokeRect(fx, fy, fw, fh);
  ctx.setLineDash([8, 6]); ctx.strokeRect(vx, vy, vw, vh); ctx.setLineDash([]);
  $("crop-range").value = Math.round(state.cropX * 1000);
  $("crop-controls").hidden = !r.movable;
  $("crop-hint").textContent = r.movable
    ? "Alles im gestrichelten Rahmen kommt auf die Tasche. Der hellere Rand wird beim Annähen umgeschlagen. Zieh das Bild nach links oder rechts, bis es passt."
    : "Alles im gestrichelten Rahmen kommt auf die Tasche. Der hellere Rand wird beim Annähen umgeschlagen.";
}

// ---------- Warenkorb ----------
function currentVariant() {
  const p = state.products[state.product];
  return p.variants.find((v) => v.farbe === state.colour && v.groesse === state.size);
}
function updateCta() {
  const p = state.products[state.product];
  const v = currentVariant() || p.variants.find((v) => v.farbe === state.colour) || p.variants[0];
  $("price").textContent = v ? `${Number(v.price).toFixed(2).replace(".", ",")} €` : "";
  $("add").disabled = !(state.image && state.size && currentVariant());
}
function cartPayload() {
  const v = currentVariant(), m = state.meta, p = state.products[state.product];
  return {
    id: v.id.replace("gid://shopify/ProductVariant/", ""),
    quantity: 1,
    properties: {
      "Design": m.name,
      ...(window.MPS_OCCASION && window.MPS_OCCASION.label ? { "Anlass": window.MPS_OCCASION.label, "_anlass": window.MPS_OCCASION.handle } : {}),
      "_design_ref": "",                 // Dateireferenz fuer die Produktion, wird beim Bestellen nach dem Upload gesetzt
      "_design_crop": String(Math.round(state.cropX * 1000) / 1000),   // Lage des Ausschnitts, fuer "Aendern" im Warenkorb
      "_design_meta": JSON.stringify({ file: m.name, type: m.type, px: [m.width, m.height], bytes: m.bytes, vector: m.vector,
        product: p.title, colour: state.colour, size: state.size, printCm: [PRINT.widthCm, PRINT.heightCm], cropX: Math.round(state.cropX * 1000) / 1000, check: state.check, ts: new Date().toISOString() }),
    },
  };
}
// Mockup-Bild fuer Warenkorb/Bestellung: Ausschnitt um das Shirt, 700 px breit, JPEG
function previewJpeg() {
  return new Promise((resolve) => {
    try {
      const src = $("stage"), out = document.createElement("canvas");
      const crop = { x: 150, y: 120, w: 800, h: 880 };                  // Shirt sitzt mittig im 1100er-Bild
      out.width = 700; out.height = Math.round(700 * crop.h / crop.w);
      const ctx = out.getContext("2d");
      ctx.fillStyle = "#FAF7F2"; ctx.fillRect(0, 0, out.width, out.height);
      ctx.drawImage(src, crop.x, crop.y, crop.w, crop.h, 0, 0, out.width, out.height);
      out.toBlob((b) => resolve(b), "image/jpeg", 0.85);
    } catch { resolve(null); }
  });
}

async function addToCart() {
  const btn = $("add"), payload = cartPayload();
  const label = btn.textContent; btn.disabled = true; btn.textContent = "Dein Design wird gespeichert …";
  try {
    if (UPLOAD_URL) {
      // Ein einziger Upload, direkt beim Bestellen
      const form = new FormData();
      form.append("file", state.file, state.meta.name);
      form.append("meta", payload.properties._design_meta);
      const preview = await previewJpeg();
      if (preview) form.append("preview", preview, "vorschau.jpg");
      const data = await uploadDesign(form, () => { btn.textContent = "Noch einen Moment, zweiter Versuch …"; });
      payload.properties._design_ref = data.ref;
      payload.properties["Design-Nr."] = data.ref;          // sichtbar fuer Kunde und Produktion
      payload.properties._design_file = data.fileId;
      if (data.fileUrl) payload.properties._design_url = data.fileUrl;           // Original, Link fuer die Produktion (Admin)
      if (data.previewUrl) payload.properties._design_preview = data.previewUrl; // Mockup, zeigt der Warenkorb statt Produktfoto
    }
    $("debug-out").textContent = JSON.stringify(payload, null, 2);

    if (THEME && UPLOAD_URL) {
      if (state.replaceKey) await fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: state.replaceKey, quantity: 0 }) }).catch(() => {});
      const res = await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: [payload] }) });
      if (!res.ok) throw new Error("Warenkorb");
      track("In den Warenkorb", { basic: state.product, farbe: state.colour });
      location.href = "/cart";
      return;
    }
    btn.textContent = "Im Warenkorb (Demo)";
  } catch (err) {
    btn.disabled = false; btn.textContent = label;
    showCheck("warn", "Das hat gerade nicht geklappt.", [String(err.message || err), "Bitte versuch es gleich noch einmal."]);
  }
}

init();

})();
